module.exports = __webpack_public_path__ + "media/Hilfevideo_LBST_Gruppen.f424fcfb.mp4";